import { HttpInterceptorFn } from '@angular/common/http';

export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  const exceptedEndPoints: string[] = [
    'googleapis.com'
  ];

  const noNeedInterceptor = exceptedEndPoints.find(endPoint => {
    return req.url.includes(endPoint);
  });

  if (noNeedInterceptor) {
    return next(req);
  }

  const modifiedReq = req.clone({
    setParams: {
      locale: getLocale(),
    },
  });

  return next(modifiedReq);
};

function getLocale(): string {
  const locale = localStorage.getItem('lang');
  return locale ? locale : 'en';
}
